import c from "../../../@babel/runtime/helpers/esm/extends.js";
import * as e from "react";
import { jsx as f } from "react/jsx-runtime";
import t from "../SvgIcon/SvgIcon.js";
function d(n, r) {
  function o(m, i) {
    return /* @__PURE__ */ f(t, c({
      "data-testid": `${r}Icon`,
      ref: i
    }, m, {
      children: n
    }));
  }
  return process.env.NODE_ENV !== "production" && (o.displayName = `${r}Icon`), o.muiName = t.muiName, /* @__PURE__ */ e.memo(/* @__PURE__ */ e.forwardRef(o));
}
export {
  d as default
};
